import { render, staticRenderFns } from "./event_list.vue?vue&type=template&id=0ca35d56&"
import script from "./event_list.vue?vue&type=script&lang=js&"
export * from "./event_list.vue?vue&type=script&lang=js&"
import style0 from "./event_list.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports